import FormattComponent from './FormattComponent.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'image',
      label: i18n.t('common_words.image'),
      toShow: true,
      show: false,
      image: true,
    },
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'description',
      label: i18n.t('common_words.description'),
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'irrigation_coefficient',
      label: i18n.t('common_words.values'),
      minWidth: 250,
      sortable: true,
      formatter: FormattComponent,
      align: 'left',
    },
  ];

  return { tableColumns };
};

export default configTable;
